import { NgModule } from '@angular/core'
import { CommonModule, NgOptimizedImage } from '@angular/common'
import { CustomThemeModule } from '../custom-theme/custom-theme.module'
import { GridsterModule } from 'angular-gridster2';
import { WidgetDirective } from './widget.directive';
import { TranslateModule } from '@ngx-translate/core'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule,
    CustomThemeModule,
    GridsterModule,
    WidgetDirective,
    NgOptimizedImage
  ],
  exports: [CommonModule, TranslateModule, CustomThemeModule, GridsterModule, WidgetDirective, NgOptimizedImage]
})
export class SharedModule { }
